import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeToSpotify}
            sections={<PairTransferGuideContent sourceKey="youtube" destKey="spotify" />}
        />
    );
}
